import { Box, Tooltip, Typography } from "@mui/material";
import IconButton from '@mui/material/IconButton';
import { AppId } from "../../app/appTypes";
import { useAppDispatch } from "../../app/hooks";
import { useCallback, useEffect, useState } from "react";
import { generatePublicToken, GenerateResult } from "../documents/publicAccessApi";
import { LoadingButton } from "@mui/lab";
import LinkIcon from '@mui/icons-material/Link';
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { Localized } from "@fluent/react";

export const PublishLink = (props: { objectId: AppId, objectType: string }) => {
    const dispatch = useAppDispatch()

    const [fetched, setFetched] = useState<undefined  | GenerateResult>(undefined)
    const [hidden, setHidden] = useState(true)
    const [loading, setLoading] = useState(false)
    const [origin, setOrigin] = useState('')

    useEffect(() => {
        setOrigin(window.location.origin)
    }, [])

    const handleFetchClick = async () => {
        if (fetched) {
            setHidden(false)
        } else {
            try {
                setLoading(true)
                const result = await dispatch(generatePublicToken({
                    objectType: props.objectType,
                    objectId: props.objectId.toString(),
                    accessLevel: 'Public',
                    maxUses: null,
                    expiresAt: null,
                })).unwrap()
                setFetched(result)
                setHidden(false)
            } catch (error) {
                console.log(error)
            } finally {
                setLoading(false)
            }
        }
    }
    const hide = useCallback(() => {
        setHidden(true)
    }, [])
    const url = fetched ? `${origin}/publish-document/${fetched.token}` : ''

    let content = <></>
    if (fetched && !hidden) {
        content = <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <Typography className="publish-link" component='div' variant='body1' sx={{ color: 'var(--purple-600)', }}>{url}</Typography>
            <Tooltip title={<Localized id=''>Kopiuj do schowka</Localized>}>
                <IconButton onClick={() => navigator.clipboard.writeText(url)}>
                    <ContentCopyIcon />
                </IconButton>
            </Tooltip>
            <Tooltip title={<Localized id=''>Ukryj link</Localized>}>
                <IconButton onClick={hide}>
                    <VisibilityOffIcon />
                </IconButton>
            </Tooltip>
        </Box>
    } else {
        content = <LoadingButton loading={loading} onClick={handleFetchClick} startIcon={<LinkIcon />} size='small' sx={{ ml: 1 }} variant='contained'>
            <Localized id='publish-doc-show-link'>Show link</Localized>
        </LoadingButton>
    }

    return content
}
